// import {} from '../action';

const defaultState = {};

function defaultReducer (state = defaultState, action) {
    switch (action.type) {
        default:
            return state;
    }
}

export default defaultReducer;
